// The last feature switches the backend sent, readable outside React (axios interceptors,
// popup helpers) without importing the store. A feature counts as enabled until the backend
// explicitly says `false`, matching `selectFeature`.
let flags = {};

export const setFeatureFlags = (next) => {
  flags = next && typeof next === "object" ? next : {};
};

export const isFeatureEnabled = (key) => flags[key] !== false;
